import {
  Card,
  Col,
  Form,
  Input,
  Row,
  Typography,
} from "antd";
import React, { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";

const { Title } = Typography;

const RequesterInformation = ({ getChildData }) => {
  const { t, i18n } = useTranslation();

  const validatePhone = useCallback((_, value) => {
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("common:please_enter_a_valid_phone_number")));
  }, [t]);

  const callparent = (value, name) => {
    getChildData(value, name);
  };

  const validationRules = useMemo(() => ({
    nameOrganization: [
      { max: 50, required: true, message: t("bulkRequest:please_enter_first_name_organization") }
    ],
    lastName: [
      { required: true, max: 50, message: t("bulkRequest:please_enter_last_name") }
    ],
    email: [
      { required: true, max: 100, message: t("bulkRequest:please_enter_email") },
      { type: "email", message: t("bulkRequest:please_enter_valid_email") }
    ],
    phone: [
      { required: true, max: 20, message: t("bulkRequest:please_enter_phone_number") },
      { validator: validatePhone }
    ],
    address1: [
      { required: true, max: 150, message: t("bulkRequest:please_enter_address") }
    ],
    city: [
      { required: true, max: 50, message: t("bulkRequest:please_enter_city_name") }
    ],
    state: [
      { required: true, max: 50, message: t("bulkRequest:please_enter_state_name") }
    ],
    zipCode: [
      { max: 8, required: true, message: t("bulkRequest:please_enter_zip_code") },
      { pattern: /^[0-9]+$/, message: t("bulkRequest:zip_code_must_be_numeric") },
      { min: 5, message: t("bulkRequest:zip_code_must_be_at_least_5_digits_long") }
    ]
  }), [t, validatePhone]);
  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          {t("bulkRequest:requester_information")}
        </Title>
      }
    >
      <Row gutter={[20, 0]} className="px-2 md:px-6">
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("bulkRequest:first_name_organization")}
            name="nameorganization"
            onChange={(e) => callparent(e.target.value, "RequesterName")}
            rules={validationRules.nameOrganization}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("bulkRequest:last_name")}
            onChange={(e) => callparent(e.target.value, "RequesterLastName")}
            name="RequesterLastName"
            rules={validationRules.lastName}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("bulkRequest:email")}
            onChange={(e) => callparent(e.target.value, "RequesterEmail")}
            name="email"
            rules={validationRules.email}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("bulkRequest:phone_number")}
            name="phone"
            onChange={(e) => callparent(e.target.value, "RequesterPhoneNumber")}
            rules={validationRules.phone}
          >
            <Input maxLength={20} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            name="address1"
            label={t("bulkRequest:address_line_1")}
            onChange={(e) => callparent(e.target.value, "RequesterAddLine1")}
            rules={validationRules.address1}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            name="address2"
            onChange={(e) => callparent(e.target.value, "RequesterAddLine2")}
            label={t("bulkRequest:address_line_2")}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="city"
            label={t("bulkRequest:city")}
            onChange={(e) => callparent(e.target.value, "RequesterCity")}
            rules={validationRules.city}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="state"
            label={t("bulkRequest:state")}
            onChange={(e) => callparent(e.target.value, "RequesterState")}
            rules={validationRules.state}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="zipcode"
            label={t("bulkRequest:zip_code")}
            onChange={(e) => callparent(e.target.value, "RequesterZipCode")}
            required
            rules={validationRules.zipCode}
          >
            <Input maxLength={8} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default RequesterInformation;
